<div class="cert-preview-layer" *ngIf="backgroundImageUrl" [ngStyle]="{'background-image': 'url(' + backgroundImageUrl + ')',
'background-size': '100% 100%',
'background-position': 'center', 'background-repeat': 'no-repeat', 'background-color': '#FFFFFF' }">

  <div class="cert-preview-company">
    <div class="preview-img-div">
      <img class="preview-img" *ngIf="base64Image" [src]="base64Image" alt="image">
    </div>
    <div class="preview-issued">
      <span class="common-labal">{{ "certificates.coverissuedTo" | translate }}</span><br>
      <span class="common-value">
      {{user.displayName}}</span>
    </div>
  </div>

  <div class="cert-preview-title">
    <div class="preview-title">{{ "certificates.title" | translate }}</div>
    <div class="preview-title-text">{{course?.certificate?.customTitle ? course.certificate.customTitle :course.title}}</div>
  </div>

  <div class="cert-preview-info">

    <table>
      <tr>
        <td><span class="common-labal">{{ "certificates.authors" | translate }}</span></td>
        <td class="scope">:</td>
        <td><span class="common-value">{{authorsName.toString()}}</span></td>
      </tr>
      <tr>
        <td><span class="common-labal">{{ "certificates.covertakenAt" | translate }}</span></td>
        <td class="scope">:</td>
        <td><span class="common-value">{{tenant.schoolName}}</span></td>
      </tr>
      <tr>
        <td><span class="common-labal">{{ "certificates.datetitle" | translate }}</span></td>
        <td class="scope">:</td>
        <td><span class="common-value">{{certificateIssuedDate | date : 'mediumDate'}}</span></td>
      </tr>
      <tr *ngIf="!course?.hideDuration">
        <td><span class="common-labal">{{ "certificates.lengthtitle" | translate }}</span></td>
        <td class="scope">:</td>
        <td>
          <span class="common-value">
            {{ "certificates.totalHours" | translate: {totalHours:course.totalDuration | duration:'hours'} }}
          </span>
        </td>
      </tr>
    </table>

  </div>

  <div class="cert-preview-description" [innerHTML]='"certificates.text" | translate: {userName:(user.displayName || "(" + nameUnavailable +")"), courseTitle: course?.certificate?.customTitle ? course.certificate.customTitle :course.title, completionDate: certificateIssuedDate | date : "shortDate", instructors: authorsName.toString(), schoolName: tenant.schoolName}'></div>

</div>
